import { UUID } from '@builddocs/data-management'
import { useMutation, useQueryClient } from 'react-query'

import { editClosingNumber } from './closing.signature.service'

export const useEditClosingName = (closingId: UUID) => {
  const queryClient = useQueryClient()

  const queryKey = ['closing', closingId]
  const { mutate, isLoading, isError, error } = useMutation({
    mutationFn: ({ name }: { name: string }) =>
      editClosingNumber({ closingId, name }),
    onSuccess: (_, variables) => {
      queryClient.setQueryData(queryKey, (oldData: any) => {
        if (oldData) {
          return { ...oldData, name: variables.name }
        }
        return oldData
      })
    },
  })

  return {
    mutate,
    isLoading,
    isError,
    error,
  }
}
